/* Copyright (C) Okahu Inc 2023-2024. All rights reserved.*/

export const formatKahuMessages = (message: string): string => {
  const uiContextRegex = /<ui_context>[\s\S]*?<\/ui_context>\s*/g;
  return message.replace(uiContextRegex, '').trim();
};
